<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepLaunch',
})
</script>
<template>
  <TlDetailItem :title="title" color="blue">
    <TlDetailField label="发起人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="发起时间">{{ record?.createdAt }}</TlDetailField>
    <TlDetailField label="监审内容名称">{{ record?.name }}</TlDetailField>
    <!-- <TlDetailField label="监审类型"><DictDisplay :value="record?.capitalExamineType" /></TlDetailField> -->
    <TlDetailField label="监审金额">{{ record?.capitalExaminePrice ?? 0 }} 元</TlDetailField>
    <TlDetailField label="报告函">
      <FileDisplayNormals :files="record?.capitalExamineReportFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="资金监审名单">
      <FileDisplayNormals :files="fundAuditUserFiles" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <div class="mt-24">
      <FundAuditUserFilePreview :dataSource="record?.capitalExamineNameListView ?? []" :useApi="false" />
    </div>
    <TlDetailField label="拆迁户建筑物、构筑物及地上附着物、人员安置统计表">
      <FileDisplayNormals :files="record?.tongJiFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
    <TlDetailField label="整改函" v-if="isRenew">
      <FileDisplayNormals :files="record?.capitalExamineUpdateFiles ?? []" :colAttrs="{ span: 12 }" />
    </TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepLaunch">
import { FileDisplayNormals } from '-/Common/FileDisplay'
import TlDetailField from '../common/TlDetailField.vue'
import TlDetailItem from '../common/TlDetailItem.vue'
// import DictDisplay from '../../DictDisplay.vue'
import FundAuditUserFilePreview from '../../FundAuditUserFilePreview/index.vue'
import { computed } from 'vue'
const props = defineProps<{
  record?: any
  isRenew?: boolean
}>()
const title = computed(() => (props.isRenew ? '重新发起' : '发起'))
// 资金监审名单
const fundAuditUserFiles = computed(() => (props.record?.capitalExamineNameListFiles ? [props.record?.capitalExamineNameListFiles] : []))
</script>
